import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=227b89e9&"
import script from "./ProductGroup.vue?vue&type=script&lang=ts&"
export * from "./ProductGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports